import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { Button, ColourStateSolid, FlexGap, StackVertical } from '@ukpostbox/frontend-framework';
import { useFieldArray, useFormContext } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React, { useEffect } from 'react';
import { RulesetFilterEntry } from './RulesetFilterEntry';
import { RulesetFiltersType } from '../../../Types/RulesetTypes';
import { RulesetFilterListData } from '../RulesetData';

function RulesetFilters(props: RulesetFiltersType) {
	const { control, getValues } = useFormContext();

	const { fields, remove, append } = useFieldArray({
		control,
		name: props.name,
		shouldUnregister: true,
	});

	const HandleFilterChange = () => {
		const activeIds: Array<number> = [];

		getValues(props.name)?.forEach((item: any) => (!Number.isNaN(item.id) ? activeIds.push(item.id) : null));

		props.filterChangedCallback(activeIds);
	};

	const MapFieldFilters = () => {
		getValues(props.name)?.forEach((filter: any) => {
			append(filter);
		});
	};

	useEffect(() => {
		if (fields.length === 0) {
			MapFieldFilters();
		}
	}, []);
	return (
		<StackVertical gap={FlexGap.Small}>
			{fields.map((field: any, fieldIndex: number) => (
				<RulesetFilterEntry
					key={field.id}
					field={field}
					nameSlug={props.name}
					fieldLength={fields.length}
					fieldIndex={fieldIndex}
					activeFilters={props.activeFilters}
					addCallback={() => HandleFilterChange()}
					removeCallback={() => {
						remove(fieldIndex);
						HandleFilterChange();
					}}
				/>
			))}

			{fields.length !== RulesetFilterListData.length && (
				<div style={{ alignSelf: 'flex-start' }}>
					<Button
						title='Add Criteria'
						squared
						colour={ColourStateSolid.Secondary}
						icon={faPlus}
						onClick={() => append({})}
					/>
				</div>
			)}
		</StackVertical>
	);
}

export { RulesetFilters };
